import { getActiveDiagram } from '../theme';
import { measureTextWidth } from './measure';
export function createEdgeLabel(app, text, x, y, accentStroke) {
    if (accentStroke === void 0) { accentStroke = getActiveDiagram().edge; }
    var fontSize = Math.max(getActiveDiagram().fontSize.sm, 12);
    var tw = measureTextWidth(text, fontSize, '700');
    var padX = 10;
    var padY = 5;
    var pw = Math.max(tw + padX * 2, 28);
    var ph = fontSize + padY * 2;
    var g = app.group({ listening: false, zIndex: 8 });
    g.add(app.roundedRect({
        x: x - pw / 2,
        y: y - ph / 2,
        width: pw,
        height: ph,
        cornerRadius: getActiveDiagram().radii.sm,
        fill: getActiveDiagram().labelPillFill,
        stroke: accentStroke,
        strokeWidth: Math.max(getActiveDiagram().stroke.label, 1.25),
        shadow: getActiveDiagram().shadowSoft,
        listening: false,
    }));
    g.add(app.text({
        text: text,
        x: x - tw / 2,
        y: y - fontSize / 2 - 1,
        fontSize: fontSize,
        fontWeight: '700',
        fontFamily: getActiveDiagram().fontFamily,
        fill: getActiveDiagram().edgeLabel,
        listening: false,
    }));
    return g;
}
